export default {
  path: '/meter-pieces/:id',
  component: () =>
    import(
      '@/components/pages/MeterPieces/MeterPiece.vue'
    )
}
